export default function usePaymentStatusPolling() {
  const businessStore = useBusinessStore()
  const userStore = useUserStore()
  const { logError } = useErrorHandling()

  const intervalId = ref<ReturnType<typeof setInterval> | null>(null)
  const isPolling = ref(false)

  const startPolling = async () => {
    // We have to wait for Chargebee webhook to update the business payment status
    // We stop polling when the status changes or after pollingTime
    isPolling.value = true
    const oldStatus = businessStore.currentPaymentStatus
    intervalId.value = setInterval(async () => {
      // An in-between failure shouldn't kill the poll, keep trying until the status
      // flips, or we stop
      try {
        await userStore.loadUserBusinessData()
      } catch (error) {
        logError('Failed to refresh business data while polling payment status', error)
        return
      }
      if (businessStore.currentPaymentStatus !== oldStatus) {
        stopPolling()
      }
    }, 500)
  }

  const stopPolling = () => {
    if (intervalId.value !== null) clearInterval(intervalId.value)
    isPolling.value = false
  }

  onUnmounted(() => {
    stopPolling()
  })

  return {
    startPolling,
    isPolling,
  }
}
